import { DuviCoreAdminAppShell } from "../../components/duvi-core-admin-app-shell";
import { useDuviCoreAdminKnowledgeBaseEditor } from "./use-duvi-core-admin-knowledge-base-editor";
import { DuviCoreAdminKnowledgeBaseEditorView } from "./duvi-core-admin-knowledge-base-editor-view";

export function DuviCoreAdminKnowledgeBaseEditor() {
  const state = useDuviCoreAdminKnowledgeBaseEditor();

  return (
    <DuviCoreAdminAppShell
      title={state.isEdit ? "Edit article" : "New article"}
      subtitle={
        state.isEdit
          ? "Update and republish"
          : "Draft a new knowledge base article"
      }
      breadcrumbs={["Knowledge Base", state.title || "New Article"]}
      headerBreadcrumbs={[
        { label: "Knowledge base", href: "/knowledge-base" },
        { label: state.isEdit ? "Edit" : "New article" },
      ]}
      activeMenuItem="Knowledge Base"
    >
      <DuviCoreAdminKnowledgeBaseEditorView {...state} />
    </DuviCoreAdminAppShell>
  );
}
